import PropTypes from 'prop-types';
import cx from 'classnames';

import { isNewSong, getRelativeTime } from '../../helpers/songDates';

import './ServiceSongList.scss';

// A service's songs as numbered rows, for the modals that list them: off a service card and in the song view
const ServiceSongList = ({ entries, onSelect, currentIndex = null, showUpdated = false, renderMeta = null }) => (
  <ul className="ServiceSongList">
    {entries.map((entry) => {
      const { song, i } = entry;
      const category = isNewSong(song.createdAt, song.isNewSong) ? 'new' : song.category?.name.toLowerCase();

      return (
        <li
          key={song._id}
          className={cx('song', category, { current: i === currentIndex })}
          onClick={() => onSelect(i)}
        >
          <span className="number">{i + 1}</span>
          <div className="info">
            <span className="title">{song.title}</span>
            {renderMeta ? renderMeta(entry) : song.artist && <span className="artist">{song.artist}</span>}
          </div>
          {showUpdated && <span className="updated">{getRelativeTime(song.contentUpdatedAt)}</span>}
        </li>
      );
    })}
  </ul>
);

ServiceSongList.propTypes = {
  // Each song with its position in the service, which a filtered list can't infer from its own order
  entries: PropTypes.arrayOf(PropTypes.shape({ song: PropTypes.object.isRequired, i: PropTypes.number.isRequired }))
    .isRequired,
  onSelect: PropTypes.func.isRequired,
  // The song on screen, filled in
  currentIndex: PropTypes.number,
  // How long ago each song was edited, for the Recently updated list
  showUpdated: PropTypes.bool,
  // What goes under the title in place of the artist, given the entry
  renderMeta: PropTypes.func,
};

export default ServiceSongList;
